import { SourceSystem } from '@atlassian/cssxp-typescommon';
import { SiteDetails } from '../types';
import { isPointAProduct } from '../utils/is-pointa-product';

const UNKNOWN_SOURCE_SYSTEM = 'Unknown source system detected';

export const useExistingSiteProvisioning = () => {
  //https://hello.atlassian.net/wiki/spaces/COMITFO/pages/2735738223/Solution+Approach+PPC+-+Provisioning+of+new+products+on+existing+site
  const validateSiteForProvisioning = ({
    siteDetails,
    products,
  }: {
    siteDetails: SiteDetails;
    products: string[];
  }): { isValid: boolean; errorMessage?: string | undefined } => {
    if (siteDetails.sourceSystem) {
      const sourceSystem = siteDetails.sourceSystem.toUpperCase();
      if (sourceSystem === SourceSystem.HAMS.toUpperCase()) {
        const isValid = products.every((productId) => isPointAProduct(productId));
        return {
          isValid,
          ...(!isValid && {
            errorMessage:
              'Only Point A products can be installed on a HAMS site. So, either select only Point A products or provide a valid CCP site for Jira/Confluence products.',
          }),
        };
      }
      const isValid = sourceSystem === SourceSystem.CCP.toUpperCase();
      return {
        isValid,
        ...(!isValid && {
          errorMessage: UNKNOWN_SOURCE_SYSTEM,
        }),
      };
    }
    return {
      isValid: false,
      errorMessage: UNKNOWN_SOURCE_SYSTEM,
    };
  };

  return {
    validateSiteForProvisioning,
  };
};
